import { useAuth } from "@/context/AuthContext";
import { AccountSecurity } from "@/components/AccountSecurity";
import { PasskeyPanel } from "@/components/PasskeyPanel";
import { PushToggle } from "@/components/PushToggle";
import { CloseCompanyPanel } from "@/components/CloseCompanyPanel";
import { DeleteLoginButton } from "@/components/DeleteLoginButton";

const ROLE_LABELS = {
  owner: "Owner", manager: "Manager", dispatcher: "Dispatcher", accountant: "Accountant",
};

export default function Profile() {
  const { user, company } = useAuth();
  const isOwner = user?.role === "owner";

  return (
    <div data-testid="profile-page" className="max-w-3xl space-y-8">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.28em] text-gold">Your account</p>
        <h1 className="mt-3 text-3xl font-bold tracking-tight text-slate-50">{user?.name}</h1>
        <p className="mt-2 text-sm text-slate-400">
          {ROLE_LABELS[user?.role] || user?.role} at {company?.name} · {user?.email}
        </p>
      </div>

      <div className="rounded-xl border border-ink-600 bg-ink-800/60 p-5">
        <p className="font-mono text-[11px] uppercase tracking-widest text-gold">Face ID unlock</p>
        <div className="mt-3">
          <PasskeyPanel testId="office-passkeys" />
        </div>
      </div>
      <AccountSecurity />
      <PushToggle scope="office"
        description="Get told on your phone the moment a new booking request lands." />

      <div className="rounded-xl border border-ink-600 bg-ink-800/60 p-6 md:p-8">
        <h2 className="text-lg font-medium text-slate-100">
          {isOwner ? "Close this account" : "Leave this company"}
        </h2>
        <p className="mt-2 text-sm text-slate-400">
          {isOwner
            ? "You own this company, so closing your account closes the whole thing. We email you an archive of your trips and invoices first."
            : "Removing your login takes away your access only. Everything the company owns stays exactly as it is."}
        </p>
        <div className="mt-6">
          {isOwner ? <CloseCompanyPanel /> : <DeleteLoginButton redirectTo="/app/login" />}
        </div>
      </div>
    </div>
  );
}
